export enum StripeEventsEnum {
	 StripeConnectedAccountUpdated = 'stripe_connected_account.updated',
}
